import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { useAgents } from "../../contexts/AgentsContext";
import { getAllChatSessions } from "../../services/clients";
import ChatSessionsTable from "../../components/Tables/ChatSessionsTable";
import ChatSession from "../../components/Chat/ChatSession";
import { Button, PageTitle } from "../../components/StyledElements";

export const ChatSessions = () => {
  const { selectedChatSession, setSelectedChatSession, agents, selectedAgent, setSelectedAgent } = useAgents();
  const { selectedClient } = useContext(AppContext);
  const [chatSessions, setChatSessions] = useState([]);

  useEffect(() => {
    const fetchChatSessions = async () => {
      try {
        setChatSessions(
          await getAllChatSessions(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchChatSessions();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <ChatSessionsTable chatSessions={chatSessions}
        allowNewChat={false}
        onSelect={(chatSession) => {

          console.log("!!! SELECTED CHAT SESSION: ", chatSession);
          const agent = agents.find((agent) => agent.id === chatSession.agent_id);
          setSelectedAgent(agent);
          console.log("!!! AGENT: ", agent);

          setSelectedChatSession(chatSession);
        }}
        style={{ display: selectedChatSession ? "none" : "block" }}
      />

      <div>
        <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
          <div>
            <PageTitle style={{ marginBottom: "5px" }} title={`${selectedChatSession?.user}'s chat with ${selectedAgent?.name}`} />
            <div>Updated at: {new Date(selectedChatSession?.updated_at).toLocaleString()}</div>
          </div>
          <Button onClick={() => {
            setSelectedChatSession(null);
          }} style={{ marginLeft: "auto" }}>Close Chat Session</Button>
        </div>
        <ChatSession chat_session_id={selectedChatSession?.public_id} agent={selectedAgent}
          style={{ flex: 1, display: selectedChatSession && selectedAgent ? "block" : "none" }}
        />
      </div>
    </div>
  );
};

export default ChatSessions;
